import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full bg-gray-800 text-gray-300 py-3 px-4 mt-auto">
      <div className="text-center text-xs sm:text-sm">
        <span>Copyright &copy; 2025, All Rights Reserved REGISTRAR OF COOPERATIVE SOCIETIES</span>
      </div>
    </footer>
  );
};

export default Footer;
